import {
  outlinedStyles,
  inputPropStyles,
} from "components/formFields/lineItemFieldStyle";
import { DatePicker } from "components/html/Input/DatePicker";

import { formatDate } from "services/utility/dates";

const dialogStyles = {
  "& .MuiDialogActions-root": { display: "block", textAlign: "right" },
};

export function LineLotExpirationDate(props) {
  const { name, onValueChange, value, error, lineReadOnly = false } = props;

  if (lineReadOnly) {
    return (
      <div style={{ fontSize: "0.8125rem" }}>
        {value instanceof Date ? formatDate(value) : ""}
      </div>
    );
  }

  const borderStyles = error ? {} : outlinedStyles;

  return (
    <DatePicker
      key={value}
      value={value instanceof Date ? value : null}
      name={name}
      onValueChange={onValueChange}
      error={error}
      textSx={{ marginTop: 0, marginBottom: 0, width: "100%", ...borderStyles }}
      inputProps={{ sx: inputPropStyles }}
      dialogProps={{ sx: dialogStyles }}
    />
  );
}
